import aa from "search-insights";

import FeatureToggles, {
    FeatureToggleKeys,
} from "@services/featureToggles.services";
import { AnalyticsEvent } from "@services/tracking/types/analyticsEvent";

import EventDataLayer from "../../queue/EventDataLayer";
import { SubscriberCallback } from "../../queue/SubscriberCallback";
import CookiePolicy from "../../util/CookiePolicy";
import { AlgoliaAnalyticsMinimumDataset } from "./AlgoliaAnalyticsMinimumDataset";
import { getAlgoliaAnalyticsAddToCartImpression } from "./mappers/AlgoliaAnalyticsAddToCartImpression";
import { getAlgoliaAnalyticsContentListmpression } from "./mappers/AlgoliaAnalyticsContentListmpression";
import { getAlgoliaAnalyticsProductClickImpression } from "./mappers/AlgoliaAnalyticsProductClickImpression";
import { getAlgoliaAnalyticsProductListmpression } from "./mappers/AlgoliaAnalyticsProductListmpression";
import { getAlgoliaAnalyticsPurchaseImpression } from "./mappers/AlgoliaAnalyticsPurchaseImpression";
import { getAlgoliaAnalyticsSearchFilterImpression } from "./mappers/AlgoliaAnalyticsSearchFilterImpression";

const AlgoliaSubscriber = (eventDataLayer: EventDataLayer) => {
    eventDataLayer.subscribe("algolia_analytics", subscribe);
};

const subscribe: SubscriberCallback = (
    event: string,
    data: AnalyticsEvent,
): void => {
    let aaData: Array<AlgoliaAnalyticsMinimumDataset> = [];

    switch (event) {
        case "product-click":
            if (!!data.payload.eventData.list) {
                aaData = getAlgoliaAnalyticsProductClickImpression(data);
            }
            break;
        case "list-impression":
            if (data.payload.eventData.name === "products") {
                aaData = getAlgoliaAnalyticsProductListmpression(data);
            }
            if (data.payload.eventData.name === "contentpages") {
                aaData = getAlgoliaAnalyticsContentListmpression(data);
            }
            break;
        case "search-filter-impression":
            aaData = getAlgoliaAnalyticsSearchFilterImpression(data);
            break;
        case "add-to-cart":
            aaData = getAlgoliaAnalyticsAddToCartImpression(data);
            break;
        case "tool-laststep":
            if (data.payload.eventData.name === "checkout") {
                aaData = getAlgoliaAnalyticsPurchaseImpression(data);
            }
            break;
        default:
            if (FeatureToggles.isEnabled(FeatureToggleKeys.ANALYTICS_LOGGING)) {
                console.info("hubo:algolia-analytics - untracked event", event);
            }
    }

    if (aaData.length > 0) {
        if (CookiePolicy.isPersonalisationCookiesEnabled()) {
            aaData.forEach(({ eventName, payload }) => aa(eventName, payload));
        }

        if (FeatureToggles.isEnabled(FeatureToggleKeys.ANALYTICS_LOGGING)) {
            console.groupCollapsed(`hubo:algolia-analytics - event`);
            console.log(aaData);
            console.groupEnd();
        }
    }
};

export { AlgoliaSubscriber };
